export default __webpack_public_path__ + "static/media/home-photography-img-09.4f2f5847.jpg";